var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 256L128.427 127.573L256 256H0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H128.427L0 138.667V0Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.427 0L0 135.253V256L128.427 127.573L256 0H128.427Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 68.0934,
    y1: 315.794,
    x2: 103.924,
    y2: 173.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09677,
    stopColor: "#0095D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3007,
    stopColor: "#238AD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6211,
    stopColor: "#557BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    stopColor: "#7472E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806EE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 17.9593,
    y1: 51.4522,
    x2: 93.1442,
    y2: -13.0382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1183,
    stopColor: "#0095D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4178,
    stopColor: "#3C83DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6962,
    stopColor: "#6D74E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8333,
    stopColor: "#806EE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -43.1006,
    y1: 235.366,
    x2: 195.121,
    y2: -2.85611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1075,
    stopColor: "#C757BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#D0609A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4254,
    stopColor: "#E1725C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6048,
    stopColor: "#EE7E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#F58613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    stopColor: "#F88909"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.4f592da40a1556e548d184a968ae9fc3.svg";
export { ForwardRef as ReactComponent };